/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/naming-convention */

import { SKPProductsInterface } from 'features/Enterprise/SKP/utils/apiList'

const RafaksiDirectDisc = (skpProducts: SKPProductsInterface[]) => ({
  headerRows: 1,
  widths: [70, 80, '*', 50, 50, 50, 50, 50, 50],
  body: [
    [
      { text: 'Product ID', style: ['tableHead', 'mt10'] },
      { text: 'Barcode', style: ['tableHead', 'mt10'] },
      { text: 'Product Name', style: ['tableHead', 'mt10'] },
      { text: 'UOM', style: ['tableHead', 'mt10'] },
      { text: 'Base Discount', style: ['tableHead', 'm5'] },
      { text: 'Price per UOM', style: ['tableHead', 'm5'] },
      { text: '% Rebate', style: ['tableHead', 'mt10'] },
      { text: 'Rebate per UOM', style: ['tableHead', 'm5'] },
      { text: 'Quantity per UOM', style: ['tableHead', 'm5'] },
    ],
    ...skpProducts.map((product) => [
      { text: product.product_id, style: 'tableContent' },
      { text: product.barcode, style: 'tableContent' },
      { text: product.sku_name, style: 'tableContent' },
      { text: product.uom, style: 'tableContent' },
      { text: product.rafaksi_base_discount, style: 'tableContent' },
      { text: product.rafaksi_price_per_uom?.toLocaleString(), style: 'tableContent' },
      { text: product.rafaksi_rebate_percentage, style: 'tableContent' },
      { text: product.rafaksi_rebate_per_uom?.toLocaleString(), style: 'tableContent' },
      {
        text:
          product.promotion_quantity === 0 && product.remarks
            ? product.remarks
            : product.promotion_quantity,
        style: 'tableContent',
      },
    ]),
  ],
})

const RafaksiBMSMDisc = (skpProducts: SKPProductsInterface[]) => ({
  headerRows: 1,
  widths: [70, 80, '*', 50, 50, 50, 50, 50, 50, 50],
  body: [
    [
      { text: 'Product ID', style: ['tableHead', 'mt10'] },
      { text: 'Barcode', style: ['tableHead', 'mt10'] },
      { text: 'Product Name', style: ['tableHead', 'mt10'] },
      { text: 'UOM', style: ['tableHead', 'mt10'] },
      { text: 'Base Discount', style: ['tableHead', 'm5'] },
      { text: 'Price per UOM', style: ['tableHead', 'm5'] },
      { text: 'Min Purchase Qty', style: ['tableHead', 'm5'] },
      { text: '% Rebate', style: ['tableHead', 'mt10'] },
      { text: 'Rebate per UOM', style: ['tableHead', 'm5'] },
      { text: 'Quantity per UOM', style: ['tableHead', 'm5'] },
    ],
    ...skpProducts.map((product) => [
      { text: product.product_id, style: 'tableContent' },
      { text: product.barcode, style: 'tableContent' },
      { text: product.sku_name, style: 'tableContent' },
      { text: product.uom, style: 'tableContent' },
      { text: product.rafaksi_base_discount, style: 'tableContent' },
      { text: product.rafaksi_price_per_uom?.toLocaleString(), style: 'tableContent' },
      { text: product.rafaksi_minimum_purchase, style: 'tableContent' },
      { text: `${product.rafaksi_rebate_percentage} %`, style: 'tableContent' },
      { text: product.rafaksi_rebate_per_uom?.toLocaleString(), style: 'tableContent' },
      {
        text: product.rafaksi_qty_per_uom ? product.rafaksi_qty_per_uom : 'as sell out',
        style: 'tableContent',
      },
    ]),
  ],
})

export const generatePdfTemplateTable = (skpProducts: SKPProductsInterface[]) => ({
  Rafaksi: RafaksiDirectDisc(skpProducts),
  'Rafaksi PWP': RafaksiDirectDisc(skpProducts),
  'Rafaksi BMSM': RafaksiDirectDisc(skpProducts),
  'Rafaksi Voucher': RafaksiDirectDisc(skpProducts),
  'Direct Discount': RafaksiDirectDisc(skpProducts),
  'Rafaksi Flexi Combo': RafaksiDirectDisc(skpProducts),
  'Flash Sale': RafaksiDirectDisc(skpProducts),
  Freebies: {
    headerRows: 1,
    widths: ['*', '*', '*', '*', '*'],
    body: [
      [
        { text: 'Product ID', style: ['tableHead', 'm5'] },
        { text: 'Barcode', style: ['tableHead', 'm5'] },
        { text: 'Product Name', style: ['tableHead', 'm5'] },
        { text: 'UOM', style: ['tableHead', 'm5'] },
        { text: 'Quantity', style: ['tableHead', 'm5'] },
      ],
      ...skpProducts.map((product) => [
        { text: product.product_id, style: 'tableContent' },
        { text: product.barcode, style: 'tableContent' },
        { text: product.sku_name, style: 'tableContent' },
        { text: product.uom, style: 'tableContent' },
        { text: product.promotion_quantity, style: 'tableContent' },
      ]),
    ],
  },
  'Product Bonus': {
    headerRows: 2,
    body: [
      [
        {
          text: 'Promo',
          style: ['tableHead', 'mergeCellMargin'],
          rowSpan: 2,
        },
        {
          text: 'Product ID',
          style: ['tableHead', 'mergeCellMargin'],
          rowSpan: 2,
        },
        {
          text: 'Barcode',
          style: ['tableHead', 'mergeCellMargin'],
          rowSpan: 2,
        },
        {
          text: 'Product Name',
          style: ['tableHead', 'mergeCellMargin'],
          rowSpan: 2,
        },
        {
          text: 'UOM',
          style: ['tableHead', 'mergeCellMargin'],
          rowSpan: 2,
        },
        {
          text: 'Quantity',
          style: ['tableHead', 'mergeCellMargin'],
          rowSpan: 2,
        },
        {
          text: 'Free Product',
          style: ['tableHead', 'm5'],
          colSpan: 5,
        },
        '',
        '',
        '',
        '',
      ],
      [
        '',
        '',
        '',
        '',
        '',
        '',
        { text: 'Product ID', style: ['tableHead', 'm5'] },
        { text: 'Product Barcode', style: ['tableHead', 'm5'] },
        { text: 'Product Name', style: ['tableHead', 'mt10'] },
        { text: 'Product UOM', style: ['tableHead', 'm5'] },
        { text: 'Product Quantity', style: ['tableHead', 'm5'] },
      ],
      ...skpProducts.map((product) => [
        { text: product.campaign_name, style: 'tableContent' },
        { text: product.product_id, style: 'tableContent' },
        { text: product.barcode, style: 'tableContent' },
        { text: product.sku_name, style: 'tableContent' },
        { text: product.uom, style: 'tableContent' },
        { text: product.promotion_quantity, style: 'tableContent' },
        { text: product.free_product_id, style: 'tableContent' },
        { text: product.free_product_barcode, style: 'tableContent' },
        { text: product.free_product_sku_name, style: 'tableContent' },
        { text: product.free_product_uom, style: 'tableContent' },
        { text: product.free_product_quantity, style: 'tableContent' },
      ]),
    ],
  },
  'Internal Campaign': RafaksiDirectDisc(skpProducts),
  'Internal Voucher': RafaksiDirectDisc(skpProducts),
  'Internal BMSM': RafaksiDirectDisc(skpProducts),
  'Internal PWP': RafaksiDirectDisc(skpProducts),
  'Internal Campaign Segmentation': RafaksiDirectDisc(skpProducts),
  'Internal Rafaksi Flexi Combo': RafaksiDirectDisc(skpProducts),
  'Rafaksi BMSM v2': RafaksiBMSMDisc(skpProducts),
  'Internal BMSM v2': RafaksiBMSMDisc(skpProducts),
})
